export default "__VITE_ASSET__By0pAdCv__"